import { useState } from 'react';
import iconeduction from '../../image/eduction.png'
import './eduction.css'
export default function Eduction() {
    const [activeSection, setActiveSection] = useState('university');

    const sections = {
      university: "دانشگاه جامع علمی-کاربردی دانشگاهی نیمه دولتی وابسته به وزارت علوم، تحقیقات و فناوری است. تأسیس دانشگاه جامع علمی-کاربردی در مهرماه سال ۱۳۷۰ به تصویب رسیده‌ است و امروزه بر اساس آمار وب سایت این دانشگاه، دارای حدود ۶۰۰ مرکز آموزشی در رشته‌های مختلف مهارتی در سراسر کشور دارد.",
      center: (
        <div>
          <p>مرکز تهران مو جهت محقق شدن اهداف و چشم‌انداز تعیین‌شده، طراحی و تدوین گردیده و در این راستا ۷ رسالت را دنبال می‌کند:</p>
          <p>1 – اهتمام ویژه جهت آموزش‌های کاربردی و مهارتی در کنار آموزش‌های کلاسیک و تئوری.</p>
          <p>2 – نظارت و کنترل بر حسن اجرای دروس عملی (کاربینی، کارورزی، پروژه).</p>
          <p>3 – انتخاب و گزینش اساتید مجرب و متخصص در حوزه کارآفرینی جهت تقویت روحیه کارآفرینی.</p>
          <p>4 – ایجاد و راه‌اندازی کانون‌های کارآفرینی جهت تشویق، ترغیب و ترویج کارآفرینی و حمایت از دانشجویان خلاق، نوآور و صاحبان ایده‌های کارآفرینی و هدایت آنان جهت تبدیل ایده‌های نو و تواضع‌محور به پدیده‌های نو.</p>
          <p>5 – مشارکت و تعامل با دستگاه‌های اجرایی و سازمان‌های دولتی و غیردولتی مرتبط با رشته‌های تحصیلی، آموزش‌های آزاد و آموزش کارکنان دولت موجود در مرکز جهت ارتقاء مهارت شاغلین و همچنین ایجاد اشتغال.</p>
          <p>6 – ایجاد و راه‌اندازی اتاق‌های فکر و نشست‌های علمی و پژوهشی در انجمن علمی، توسط اعضای انجمن علمی و اساتید منتخب جهت عملیاتی نمودن نتایج پژوهش و همچنین ایجاد بسترهای خلاقیت، نوآوری، ابتکار و اختراع.</p>
          <p>7 – ایجاد و راه‌اندازی مرکز رشد و شرکت دانش‌بنیان جهت تبدیل ایده به پدیده‌ها، همچنین محقق شدن خلق ثروت در بستر دانش و مستحکم شدن ارتباط با صنعت.</p>
        </div>
      ),
      president: (
        <div>
          <p>سپاس خداوندی را که انسان را به زیور علم و دانایی آراسته و رحمت بی پایان خود را بر وی ارزانی داشته است و اهداء سلام و صلوات بر پیشگاه پیامبر اکرم (ص) و خاندان پاک و مطهرش.</p>
          <p>ورود دانشجویان گرامی را به عرصه علم و معرفت که توأم با رشد و بالندگی نظام مقدس جمهوری اسلامی است خوشامد می‌گویم. دانشگاه‌ها به عنوان کانون امید به پیشرفت و تعالی جامعه وظیفه تولید علم و آگاهی را بر عهده دارند و این مهم با سخت‌کوشی، جدیت و پشتکار اساتید و شما دانشجویان عزیز رقم خواهد خورد.</p>
          <p>مرکز علمی-کاربردی تهران مو با اعتقاد به وفاق و تلاش عمومی برای توسعه هر چه بیشتر علمی، آموزشی، فرهنگی و ترویج فرهنگ اسلامی تمام مساعی خود را در جهت شکوفایی استعدادها و خلاقیت دانشجویان صرف خواهد نمود تا دستیابی به یک مرکز پویا و بالنده در خور نظام مقدس ممکن گردد.</p>
          <p>مایه سربلندی و خرسندی است که ورود شما عزیزان را به مرکز علمی-کاربردی تهران مو خوشامد گفته و خداوند منان را شاکرم که افتخار خدمتگزاری به شما عزیزان را به ما ارزانی کرده است و در نهایت از محضر آفریدگار حکیم استمرار توفیقتان را در جمیع جهات خواستارم.</p>
          <p>دکتر سحر نماینده</p>
          <p>رئیس مرکز علمی-کاربردی تهران مو</p>
        </div>
      ),
      education: (
        <div>
          <p>اهداف در حوزه معاونت آموزشی:</p>
          <p>1- ارتقاء جایگاه آموزش با کیفیت جهت افزایش کیفیت فارغ‌التحصیلان در کلیه مقاطع کارشناسی، کارشناسی ارشد و دکتری به عنوان کارشناسان، محققان و مدیران آینده کشور که از مؤلفه‌های اساسی و تعیین‌کننده توسعه کشور و رسیدن کشور به جایگاه بالای علمی، اقتصادی و رفاهی می‌باشد.</p>
          <p>2- کاهش درصد دانشجویان اخراجی و فارغ‌التحصیلان با کیفیت پایین در راستای افزایش راندمان، کاهش هزینه‌های تلف شده، کم شدن سرخوردگی و تبعات اجتماعی و فردی آن.</p>
          <p>3- ایجاد بستر لازم برای تحقیقات پایه‌ای، توسعه‌ای و کاربردی، با توجه به اینکه انجام رسالت دانشگاه در جهت کاربردی کردن علم منوط به توسعه تحقیقات پایه‌ای و تحقیقات پایه‌ای اساساً در گرو آموزش‌های قوی و مناسب است.</p>
          <p>4- توسعه برنامه‌های آموزشی متنوع برای تحت پوشش قرار دادن طیف وسیع‌تری از اقشار جامعه و امکان ارائه علوم مختلف متناسب با نیازهای جامعه.</p>
        </div>
      )
      }
      function title() {
        document.title = 'تهران مو | آموزش'
      }
      title()
    return (
      <div className="education-page">
        <div className="university-logo">
          <img src={iconeduction} alt="University Logo" />
        </div>
        <ul className="education-menu">
          <li className={activeSection === 'university' ? 'active' : ''}
              onClick={() => setActiveSection('university')}>
            معرفی دانشگاه
          </li>
          <li className={activeSection === 'center' ? 'active' : ''}
              onClick={() => setActiveSection('center')}>
            معرفی مرکز
          </li>
          <li className={activeSection === 'president' ? 'active' : ''}
              onClick={() => setActiveSection('president')}>
            ریاست مرکز
          </li>
          <li className={activeSection === 'education' ? 'active' : ''}
              onClick={() => setActiveSection('education')}>
            معاونت آموزش و پرورش
          </li>
        </ul>
  
        {/* محتوای متن */}
        <div className="content">
          <p>{sections[activeSection]}</p>
        </div>
      </div>
    );
  }